module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="form-group listerecap-dialogPopupHeader">\r\n  <fieldset class="listerecap-dialogPopupHeader cw-fieldset">\r\n    <div class="input-group">\r\n        <div class="phx-listerecap-data">\r\n          <label for="commentaire" class="cw-label-entrezcomment text-left" title="'+
((__t=(i18n.t("common:listerecap.commentaires")))==null?'':__t)+
'">'+
((__t=(UTILS.getSVGIcon('bulle','',16)))==null?'':__t)+
' '+
((__t=(i18n.t("common:listerecap.commentaires")))==null?'':__t)+
'</label>\r\n          <textarea class="commentaire form-control" rows="6" cols="40" maxlength="60" style="resize:none"></textarea>\r\n          <div class="cw-texteSuperAllege">\r\n            '+
((__t=(i18n.t("common:listerecap.comment_popup1")))==null?'':__t)+
'<br/>\r\n            '+
((__t=(i18n.t("common:listerecap.comment_popup2")))==null?'':__t)+
'\r\n          </div>\r\n          <span class="checkedRecap c-form__groupCheckbox c-form__groupCheckbox--vertical">\r\n            <div class="c-form__labelCheckbox">\r\n              <input type="checkbox" name="demande" class="isForced demande c-form__checkbox" value="checkForcer" title="'+
((__t=(i18n.t("common:listerecap.forcer")))==null?'':__t)+
'" />\r\n              <span for="isForced" class="c-form__label">'+
((__t=(i18n.t("common:listerecap.forcer")))==null?'':__t)+
'</span>\r\n            </div>\r\n        </span>\r\n        </div>\r\n      </div>\r\n  </fieldset>\r\n</div>\r\n\r\n';
}
return __p;
};
